<template>
  <ib-blinking-animation
    :text="`${$t('generatingTemplate')}`"
    handwriting
    font-size="18px"
    variant="violet"
  />
</template>

<script>
import IbBlinkingAnimation from '@/components/_v2/IbBlinkingAnimation/IbBlinkingAnimation.vue'

export default {
  name: 'AiTemplateBlinkingAnimation',

  components: { IbBlinkingAnimation }
}
</script>
